import React, { ReactNode } from "react";
import { Button, ButtonProps, styled, useTheme } from "@mui/material";
import { useTranslation } from "../../helpers/i18n";
import { defaultFocusOutline } from "../../helpers/accessibility";

const TextButton = styled("span")(({ theme }) => ({
  display: "none",
  fontSize: theme.typography.h6.fontSize,
  fontWeight: "bold",
  [theme.breakpoints.up("md")]: {
    display: "unset",
  },
}));

interface Props {
  textColor?: string;
}

const StyledButton = styled(Button)<Props>(({ theme, textColor }) => ({
  "&:hover": {
    backgroundColor: "transparent",
  },
  textTransform: "initial",
  zIndex: theme.zIndex.appBar,
  color: textColor || `${theme.palette.text.default} !important`,

  "&.Mui-focusVisible": {
    outline: defaultFocusOutline(theme),
    outlineOffset: 4,
  },
  "& .MuiButton-startIcon": {
    margin: 0,
  },
  [theme.breakpoints.up("md")]: {
    padding: 0,
    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(1),
      marginLeft: -theme.spacing(0.5),
    },
  },
}));

export const BackButton = styled(
  React.forwardRef(
    (
      props: ButtonProps &
        Props & {
          children?: ReactNode;
        },
      ref: React.Ref<HTMLButtonElement>,
    ) => {
      const theme = useTheme();
      const { t } = useTranslation();
      const backButtonText =
        theme.settings.backButtonText || t("information_previous");
      const ArrowBackIcon = theme.icons.arrowBack;
      return (
        <StyledButton
          ref={ref}
          {...props}
          disableRipple
          startIcon={<ArrowBackIcon fill={props.textColor} />}
          variant="text"
          aria-label={backButtonText}
        >
          <TextButton>{backButtonText}</TextButton>
        </StyledButton>
      );
    },
  ),
)<Props>(() => ({}));
